import {Chip} from "@mui/material";
import {colors, Consts} from "../pages/consts";
import React from "react";

const SymptomSeverities = ({category, symptom, symptomNumber, handleSelectedSufferingLevel}) => {
  const calcBorder = (sufferingLevel) =>
    symptom?.sufferingLevel === sufferingLevel ? "4px solid #0000FF" : Consts.NONE;

  return (
    <div
      className="w3-row w3-center"
      style={{ display: "flex", justifyContent: "space-between", gap: 8, flexWrap: "wrap" }}>
      {Array.from({ length: 5 }, (_, idx) => idx + 1).map((sufferingLevel, k) => (
        <div key={`symptom-${symptomNumber}-ans-${k}`} style={{ flex: "1 1 18%", minWidth: 80 }}>
          <Chip
            id={`${k}`}
            name={`${k}`}
            value={sufferingLevel}
            label={<span className="w3-text-white">{sufferingLevel}</span>}
            sx={{
              backgroundColor: colors[sufferingLevel], // colors[1..5]
              border: calcBorder(sufferingLevel),
              color: "#0000FF",
              width: "100%",
              cursor: "default",
            }}
            onClick={() => handleSelectedSufferingLevel(sufferingLevel, symptomNumber)}
          />
        </div>
      ))}
    </div>
  );
}

export default SymptomSeverities;